import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaItem: [],
	listaTipo: [],
	filtro: {
		data_inicial: DateFormat.getDataInicioMesAtual(),
		data_final: DateFormat.getDataAtual()
	}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'LANCAMENTO_VIAGEM_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'LANCAMENTO_VIAGEM_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'LANCAMENTO_VIAGEM_LISTADO':
            return {
                ...state, 
                lista: action.payload.data
            };

		case 'LANCAMENTO_VIAGEM_ITEM_LISTADO':
            return {
                ...state, 
                listaItem: action.payload.data
            };

		case 'LANCAMENTO_VIAGEM_TIPO_LISTADO':
            return {
                ...state, 
                listaTipo: action.payload.data
            };

        default:
            return state;
    }
}
